import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface IUnsubscribePayload {
  feedback: string;
}

export const subscribeApi = createApi({
  reducerPath: 'subscribeApi',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    unsubscribe: builder.mutation<void, IUnsubscribePayload>({
      query: ({ feedback }) => ({
        url: `/trustpay/unsubscribe`,
        method: 'POST',
        body: { feedback },
      }),
    }),
  }),
});

export const { useUnsubscribeMutation } = subscribeApi;
